import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { CustomInputType } from '../_common/_enum/module.enum';

@Pipe({
  name: 'formatInputType'
})
export class FormatInputTypePipe implements PipeTransform {

  constructor(private currencyPipe: CurrencyPipe) { }

  transform(value: any, ...args: any): any {
    args = args[0];
    if (args.psiCustomInputType == CustomInputType.PHONE) {
      value = value.replace(/[^0-9]+/g, "");
      value = value.substring(0, 10);
    } else {
      value = value.replace(/[^0-9.-]+/g, "");
    }
    let otherAmount, convertedValue;

    if (!args.allowBlank || value.replace(/[^0-9.-]+/g,"")) {//
        if (args.psiCustomInputType == CustomInputType.PHONE) {
          otherAmount = Number(value.replace(/[^0-9]+/g,""));//.replaceAll("$", "").replaceAll(",", "").replaceAll(" ", "");
          otherAmount = value.substring(0, 10);
        } else {
          otherAmount = Number(value.replace(/[^0-9.-]+/g,""));//.replaceAll("$", "").replaceAll(",", "").replaceAll(" ", "");
        }
        if (isNaN(otherAmount) || (!args.allowBlank && otherAmount.toString() == "")) {
          convertedValue = "";
        }
        else { 
            if (args.maximumFractionDigits > 0) {
              otherAmount = parseFloat(otherAmount);
            } else {
              if(args.psiCustomInputType == CustomInputType.AMOUNT){
                otherAmount = Math.round(otherAmount); 
              }
              otherAmount = parseInt(otherAmount);
            }
        }
    } else {
      convertedValue = "";
    }

    if (convertedValue != "" && args.psiCustomInputType == CustomInputType.AMOUNT) {
      if(args.maximumFractionDigits > 0){
        convertedValue = this.currencyPipe.transform(otherAmount, '$', 'symbol', '1.'+args.maximumFractionDigits+"-"+args.maximumFractionDigits);
      } else {
        convertedValue = this.currencyPipe.transform(otherAmount, '$', 'symbol', '1.0-0');
      }

    } else if (convertedValue != "" && args.psiCustomInputType == CustomInputType.PHONE) {
      if (otherAmount.toString().length === 0) {
        convertedValue = '';
      } else if (otherAmount.toString().length <= 3) {
        convertedValue = otherAmount.toString().replace(/^(\d{0,3})/, '($1)');
      } else if (otherAmount.toString().length <= 6) {
        convertedValue = otherAmount.toString().replace(/^(\d{0,3})(\d{0,3})/, '($1)$2');
      } else if (otherAmount.toString().length <= 10) {
        convertedValue = otherAmount.toString().replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1)$2-$3');
      } else {
        convertedValue = otherAmount.toString().substring(0, 10);
        convertedValue = otherAmount.toString().replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1)$2-$3');
      }
      /* let _numberFormatOption = { maximumFractionDigits: args.maximumFractionDigits };
      convertedValue = new Intl.NumberFormat('en-US', _numberFormatOption).format(otherAmount); */
    } else if (convertedValue != "" && args.psiCustomInputType == CustomInputType.NUMBER) {
      let _numberFormatOption = { maximumFractionDigits: args.maximumFractionDigits };
      convertedValue = new Intl.NumberFormat('en-US', _numberFormatOption).format(otherAmount);
    }
    return convertedValue;
  }

}
